export default __webpack_public_path__ + "static/media/menuArrowRight.d9ba5ffc.svg";